import { useMutation } from '@apollo/client';
import React from 'react';
import {
  InvoiceSigningExportFilterInput,
  SearchRequestInput,
} from 'common/types/globalTypes';
import { InvoiceRow } from 'ap/signing/types';
import {
  InvoiceSigningExportFilter,
  InvoiceSigningExportFilterVariables,
} from './__generated__/invoiceSigningExportFilter';
import { FilterArrayType } from 'common/components/Filters';
import { toInvoiceSigningFilterVariableExport } from './utils';
import {
  AccountingExportCycleFn,
  AccountingExportToCsv,
} from 'common/components/AccountingExportToCsv';

import INVOICE_SIGNING_EXPORT_FILTER from './invoiceSigningExportFilter.graphql';
import { toSelection } from 'common/utils/entity';

interface ExportInvoicesProps {
  selectedRows: InvoiceRow[];
  isSelectedAll: boolean;
  isSigningSearch: boolean;
  searchFilters: FilterArrayType[];
  searchRequestInput: SearchRequestInput | null;
  isHistorySearch: boolean;
  isSearchAllData: boolean;
  isLinkSearch: boolean;
  filterSupplierId: string | undefined;
}

export const ExportInvoices: React.FC<ExportInvoicesProps> = ({
  selectedRows,
  isSelectedAll,
  isSigningSearch,
  searchFilters,
  searchRequestInput,
  isHistorySearch,
  isSearchAllData,
  isLinkSearch,
  filterSupplierId,
}) => {
  const [invoiceExport] = useMutation<
    InvoiceSigningExportFilter,
    InvoiceSigningExportFilterVariables
  >(INVOICE_SIGNING_EXPORT_FILTER);

  const getExportCycle: AccountingExportCycleFn = async (
    desc,
    acctPeriod,
    includeDist
  ) => {
    let exportVariable: InvoiceSigningExportFilterInput = {
      exportDescription: desc,
      corporatePeriodId: acctPeriod,
      isDistributionIncluded: includeDist,
    };

    if (isSelectedAll) {
      const filterVariable = toInvoiceSigningFilterVariableExport(
        searchFilters ?? []
      );
      exportVariable = {
        ...exportVariable,
        searchRequest: searchRequestInput,
        isLinkSearch,
        isSigningSearch,
        isHistorySearch,
        isSearchAllData,
        filterSupplierId,
        ...filterVariable,
      };
    } else if (selectedRows.length > 0) {
      exportVariable = {
        ...exportVariable,
        entityDelete: selectedRows.map(toSelection),
      };
    }

    const { errors, data } = await invoiceExport({
      variables: { input: exportVariable },
    });

    return {
      id: data?.invoiceSigningExportFilter?.exportResult?.exportCycles?.[0],
      errors,
    };
  };

  return (
    <AccountingExportToCsv
      isButtonVisible={isSelectedAll || selectedRows.length > 0}
      title="Enter the description and press confirm to download the transaction worksheet."
      getExportCycle={getExportCycle}
    />
  );
};
